import React from 'react'
import PropTypes from "prop-types";
import Pagination from "react-js-pagination";

export const PaginationComponent = props => {
    const {
        activePage,
        itemsCountPerPage,
        totalItemsCount,
        pageRangeDisplayed,
        onChange,
        hideFirstLastPages
    } = props;

    return (
        <section className="pagination-marketing">
            <Pagination
                innerClass={"pagination--marketing"}
                activePage={activePage}
                itemsCountPerPage={itemsCountPerPage}
                totalItemsCount={totalItemsCount}
                pageRangeDisplayed={pageRangeDisplayed}
                onChange={onChange}
                hideFirstLastPages={hideFirstLastPages}
            />
        </section>
    );
};

PaginationComponent.propTypes = {
    activePage: PropTypes.number,
    itemsCountPerPage: PropTypes.number,
    totalItemsCount: PropTypes.number,
    pageRangeDisplayed: PropTypes.number,
    onChange: PropTypes.func
};



// WEBPACK FOOTER //
// src/client/components/common/elements/PaginationComponent.js